export default {
  functional: true,
  render(createElement, { props }) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Item = require('./Item.js').default;
    return props.items?.map(item => createElement(Item, {
      props: {
        item,
        ...props,
      },
    }));
  },
};
